import { useMutation } from "urql";

import { CreateCollectionDocumentDocument } from "../../../graphql/generated.ts";

export function useCreateCollectionDocument() {
  return useMutation(CreateCollectionDocumentDocument);
}
